const STATUS_COLOURS = [
    { key: "success", color: "#00d27a" },
    { key: "warning", color: "#f5803e" },
    { key: "danger", color: "#e63757" },
    { key: "unknown", color: "#adb5bd" },
];

export const StatusBar = ({ counts, labels, barPrefix, barMargin = "0 12px", legendClassName = "px-3" }) => {
    const segments = STATUS_COLOURS.filter(({ key }) => key in counts)
    const total = segments.reduce((acc, { key }) => acc + counts[key], 0)
    const baseStyle = { height: "10px", margin: barMargin, borderRadius: "9999px" };

    const barStyle = (() => {
        if (total === 0) return { ...baseStyle, background: "#e9ecef" };
        let offset = 0;
        const stops = segments.map(({ key, color }) => {
            const pct = (counts[key] / total) * 100;
            const stop = `${ color } ${ offset }% ${ offset + pct }%`;
            offset += pct;
            return stop;
        }).join(", ");
        return { ...baseStyle, background: `linear-gradient(to right, ${ stops })` };
    })()

    return (
        <>
            {
                barPrefix
                    ? <div className="d-flex align-items-center">
                        { barPrefix }
                        <div className="flex-grow-1" style={ barStyle }></div>
                    </div>
                    : <div style={ barStyle }></div>
            }
            <div className={ `d-flex flex-wrap ${ labels ? "mt-1" : "mt-2" } ${ legendClassName }` }>
                { segments.map(({ color, key }) => (
                    <div key={ key } className={ `d-flex align-items-center ${ labels ? "mr-2" : "mr-3" }` }>
                        <div style={ { width: labels ? "8px" : "12px", height: labels ? "8px" : "12px", borderRadius: "9999px", background: color, flexShrink: 0 } } />
                        {
                            labels
                                ? <p className='m-0 ml-1 fs--2 text-nowrap'>{ labels[key] } ({ counts[key] })</p>
                                : <p className='m-0 ml-1'>{ counts[key] }</p>
                        }
                    </div>
                )) }
            </div>
        </>
    )
}
